import { useTranslation } from 'react-i18next';

import { OpPage } from 'new-components/OpPage/OpPage';

import { ReleaseNote } from './ReleaseNote';
import { getReleaseNotes } from './getReleaseNotes';

// NOTE I did not spend much time and effort on this as it is currently still in UX Design.
// I needed a quick and dirty version of the Access page in Mailroom. But this will be some throwaway work.
const ReleaseNotes = () => {
  const { t } = useTranslation();
  const mailroomReleaseNotes = getReleaseNotes(t);
  return (
    <OpPage title={t('Release notes')} className="release-notes">
      {mailroomReleaseNotes.map((release) => (
        <ReleaseNote
          date={release.date}
          notes={release.notes}
          key={release.id}
        />
      ))}
    </OpPage>
  );
};

export default ReleaseNotes;
